import css from './index.module.scss';
import TextA1 from './textA1';

export default function AnimationG({}: any) {
    return (
        <>
            <div className={`${css.animationG} animationG`}>
                <div className="ef-scroll-ani-total-box">
                    <div className="ef-scroll-ani">
                        <div className="ef-scroll-ani-trigger">
                            <div className="ef-scroll-ani-inter">
                                <TextA1 />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
